// =============================================================================
// Agent Types
// =============================================================================
/** Supported agent identifiers */
export const AGENT_TYPE_VALUES = [
    'claude-code',
    'openai-codex',
    'google-gemini',
    'mistral-vibe',
    'opencode',
    'amp',
];
/** API key provider identifiers */
export const AGENT_PROVIDER_VALUES = [
    'anthropic',
    'openai',
    'google',
    'mistral',
    'opencode',
    'amp',
];
// =============================================================================
// Agent Catalog
// =============================================================================
/** All supported agents and their configuration */
export const AGENT_CATALOG = [
    {
        id: 'claude-code',
        name: 'Claude Code',
        description: "Anthropic's AI coding agent",
        provider: 'anthropic',
        envVarName: 'ANTHROPIC_API_KEY',
        acpCommand: 'claude-agent-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://console.anthropic.com/settings/keys',
        oauthSupport: {
            envVarName: 'CLAUDE_CODE_OAUTH_TOKEN',
            setupInstructions: 'Generate a token using "claude setup-token" or "claude login" in your terminal',
            subscriptionUrl: 'https://claude.ai/settings/plan',
        },
    },
    {
        id: 'openai-codex',
        name: 'OpenAI Codex',
        description: "OpenAI's AI coding agent",
        provider: 'openai',
        envVarName: 'OPENAI_API_KEY',
        acpCommand: 'codex-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://platform.openai.com/api-keys',
        oauthSupport: {
            envVarName: 'CODEX_AUTH_JSON',
            setupInstructions: 'Run "codex login" on your local machine and sign in with your ChatGPT account, then paste the contents of ~/.codex/auth.json',
            subscriptionUrl: 'https://openai.com/chatgpt/pricing/',
        },
    },
    {
        id: 'google-gemini',
        name: 'Gemini CLI',
        description: "Google's AI coding agent",
        provider: 'google',
        envVarName: 'GEMINI_API_KEY',
        acpCommand: 'gemini',
        acpArgs: ['--acp'],
        supportsAcp: true,
        credentialHelpUrl: 'https://aistudio.google.com/apikey',
    },
    {
        id: 'mistral-vibe',
        name: 'Mistral Vibe',
        description: "Mistral AI's coding agent",
        provider: 'mistral',
        envVarName: 'MISTRAL_API_KEY',
        acpCommand: 'vibe-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://console.mistral.ai/api-keys',
    },
    {
        id: 'opencode',
        name: 'OpenCode',
        description: 'Open-source AI coding agent by SST. Uses OpenCode managed inference.',
        provider: 'opencode',
        envVarName: 'OPENCODE_API_KEY',
        acpCommand: 'opencode',
        acpArgs: ['acp'],
        supportsAcp: true,
        credentialHelpUrl: 'https://opencode.ai/auth',
    },
    {
        id: 'amp',
        name: 'Amp',
        description: "Sourcegraph's managed AI coding agent",
        provider: 'amp',
        envVarName: 'AMP_API_KEY',
        acpCommand: 'acp-amp',
        acpArgs: ['run'],
        supportsAcp: true,
        credentialHelpUrl: 'https://ampcode.com/settings',
    },
];
/** Look up an agent definition by ID */
export function getAgentDefinition(agentType) {
    return AGENT_CATALOG.find((a) => a.id === agentType);
}
/** Validate that a string is a valid agent type */
export function isValidAgentType(value) {
    return AGENT_CATALOG.some((a) => a.id === value);
}
//# sourceMappingURL=agents.js.map